import React from "react"
import { Flex, Tag } from "antd"

import { TagOutlined, AppstoreOutlined } from "@ant-design/icons"
import { useWizardContext } from "../../../WizardContext"
import styles from "./PreviewCategories.module.css"
import { Text } from "ui/Typography"

export const PreviewCategories = () => {
  const { form } = useWizardContext()
  const categories = form.getFieldValue("categories") || []
  const languages = form.getFieldValue("languages") || []
  const marketplaceTags = form.getFieldValue("marketplace_tags") || []

  if (!categories.length && !languages.length && !marketplaceTags.length) return null

  return (
    <Flex vertical gap="small" className={styles.container}>
      {categories.length > 0 && (
        <Flex align="center" gap="small">
          <AppstoreOutlined className={styles.groupIcon} />
          <Text strong>Categories</Text>
          <Flex wrap="wrap" gap="small">
            {categories.map((c) => (
              <Tag key={c} className={styles.tag}>{c}</Tag>
            ))}
          </Flex>
        </Flex>
      )}
      {marketplaceTags.length > 0 && (
        <Flex align="center" gap="small">
          <TagOutlined className={styles.groupIcon} />
          <Text strong>Tags</Text>
          <Flex wrap="wrap" gap="small">
            {marketplaceTags.map((tag) => (
              <Tag key={tag} color="green" className={styles.tag}>{tag}</Tag>
            ))}
          </Flex>
        </Flex>
      )}
    </Flex>
  )
}
